import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { stopImpersonate, reset } from '../store/slices/authSlice';
import { AlertTriangle, X } from 'lucide-react';
import { toast } from 'react-toastify';

const ImpersonationBanner = () => {
  const dispatch = useDispatch();
  const { impersonating, originalUser, user } = useSelector(state => state.auth);
  const [isLoading, setIsLoading] = React.useState(false);

  const handleStopImpersonation = async () => {
    setIsLoading(true);
    try {
      await dispatch(stopImpersonate()).unwrap();
      toast.success(`Returned to ${originalUser?.name || 'your account'}`);
      dispatch(reset());
    } catch (error) {
      toast.error(error || 'Failed to stop impersonation');
    } finally {
      setIsLoading(false);
    }
  };

  if (!impersonating || !originalUser) {
    return null;
  }

  return (
    <div className="bg-orange-500 text-white shadow-lg z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <AlertTriangle className="h-5 w-5 flex-shrink-0" />
            <div className="flex-1">
              <p className="text-sm font-medium">
                You are currently impersonating <span className="font-bold">{user?.name}</span>
              </p>
              <p className="text-xs mt-0.5 opacity-90">
                Original account: {originalUser.name} ({originalUser.role})
              </p>
            </div>
          </div>
          <button
            onClick={handleStopImpersonation}
            disabled={isLoading}
            className="flex items-center space-x-2 bg-white text-orange-600 hover:bg-orange-50 px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <X className="h-4 w-4" />
            <span>{isLoading ? 'Stopping...' : 'Stop Impersonation'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
